import React, { useEffect, useState } from 'react';
import styles from './group-participants-page.module.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addAccessToMenuBd, deleteClientGroupBd, getClientsDb } from '../../firebase';
import {
  accessToMenuRedux,
  addClientsRedux,
  deleteParticipanRedux,
} from '../../store/slices/clientsSlice';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { pathHome } from '../../path';

export default function GroupParticipantsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { group_id } = useParams();

  const [loaderPage, setLoaderPage] = useState(false);
  const [copyClientIdTrue, setCopyClientIdTrue] = useState(false);

  const clients = useSelector((state) => state.clients.clients);

  useEffect(() => {
    if (!clients.length) {
      setLoaderPage(true);
      const getClients = async () => {
        const clients = await getClientsDb();
        dispatch(addClientsRedux(clients));
        setLoaderPage(false);
      };
      getClients();
    }
  }, []);

  // console.log(group_id);

  // Відбирає учасників які є учасниками цієї групи
  const getClientsParticipationGroup = (clients) => {
    const clientsParticipationGroup = [];
    clients.forEach((item) => {
      const participationGroupsKeys = Object.keys(item.participationGroups);

      if (participationGroupsKeys.length) {
        for (let index = 0; index < participationGroupsKeys.length; index++) {
          const itemGroupInfo = item.participationGroups[participationGroupsKeys[index]];
          if (group_id === itemGroupInfo.group_id) {
            clientsParticipationGroup.push({
              item,
              itemGroupInfo,
              groupObject_link: participationGroupsKeys[index],
            });
            break;
          }
        }
      }
    });

    return clientsParticipationGroup;
  };

  // Видаляє клієнта з групи
  const deleteClientWithGroup = async (item, group_id) => {
    let isRemove = window.confirm('Видалити учасника групи?');

    if (isRemove) {
      setLoaderPage(true);
      const client_id = item.item.client_id;
      const groupObject_link = item.groupObject_link;

      const isDeleteClientGroupBd = await deleteClientGroupBd(
        client_id,
        groupObject_link,
        group_id,
      );

      if (isDeleteClientGroupBd) {
        dispatch(deleteParticipanRedux({ client_id, groupObject_link }));
      }
      setLoaderPage(false);
    }
  };

  // Додає, забирає  доступ до меню
  const accessToMenu = (clientsItems, isAccess, askOnChange = false) => {
    if (askOnChange && !isAccess) {
      let isChange = window.confirm('Забрати доступ до меню?');

      if (!isChange) {
        return;
      }
    }

    const addAccess = async (client_id, groupObject_link) => {
      setLoaderPage(true);
      const isAccessBd = await addAccessToMenuBd(client_id, groupObject_link, isAccess, group_id);

      if (isAccessBd) {
        dispatch(accessToMenuRedux({ client_id, groupObject_link, isAccess }));
      }
      setLoaderPage(false);
    };

    clientsItems.forEach((item) => {
      const client = item.item;
      const groupObject_link = item.groupObject_link;
      addAccess(client.client_id, groupObject_link);
    });
  };

  const copyClientId = (client_id) => {
    navigator.clipboard
      .writeText(client_id)
      .then(() => {
        setCopyClientIdTrue(client_id);
        setTimeout(() => {
          setCopyClientIdTrue(false);
        }, 700);
      })
      .catch((err) => {
        alert('Не вдалося Скопіювати!');
        console.log(err);
      });
  };

  // Рендерить учасників групи
  const renderClientsParticipationGroup = (clients) => {
    return clients.map((item) => {
      return (
        <div
          key={item.item.client_id}
          className={
            item.item.fromAdvertising
              ? styles.client_wrapper + ' ' + styles.client_wrapper_fromAdvertising
              : item.item.ownСlient
              ? styles.client_wrapper + ' ' + styles.client_wrapper_ownСlient
              : item.item.potentialClient
              ? styles.client_wrapper + ' ' + styles.client_wrapper_potentialClient
              : styles.client_wrapper
          }>
          <div>
            <Link
              className={styles.client_link}
              to={`/${pathHome}/client-info/${item.item.client_id}`}>
              {item.item.fullName}
            </Link>
          </div>
          <div className={styles.client_btn_wrapper}>
            <button
              className={styles.copy_clientId_btn}
              onClick={() => copyClientId(item.item.client_id)}>
              K
              {copyClientIdTrue === item.item.client_id && (
                <div className={styles.alertCopyTrue}>Скопійовано!</div>
              )}
            </button>
            <svg
              onClick={() => deleteClientWithGroup(item, group_id)}
              className={styles.client_delete_btn}
              width="24"
              height="25"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 3H18V18C18 19.1046 17.1046 20 16 20H5C3.89543 20 3 19.1046 3 18V3Z"
                fill="#FF5C5E"
              />
              <rect width="21" height="2" rx="1" fill="#FF5C5E" />
            </svg>
            <button
              onClick={() => accessToMenu([item], !item.itemGroupInfo.accessGroup, true)}
              className={
                item.itemGroupInfo.accessGroup
                  ? styles.change_selected_btn + ' ' + styles.change_selected_btn_active
                  : styles.change_selected_btn
              }
            />
          </div>
        </div>
      );
    });
  };

  // Підраховує клієнти з реклами
  const getClientCountFromAdvertising = (clients) => {
    let count = 0;
    clients.forEach((client) => {
      if (client.item.fromAdvertising) {
        count++;
      }
    });
    return count;
  };
  // Підраховує клієнти які вже були на супроводі
  const getClientCountOwnСlient = (clients) => {
    let count = 0;
    clients.forEach((client) => {
      if (client.item.ownСlient) {
        count++;
      }
    });
    return count;
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <div className={styles.header_wrapper}>
        <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
        <div>
          Учасники{' '}
          {clients.length && getClientsParticipationGroup(clients).length
            ? getClientsParticipationGroup(clients).length +
              ' / ' +
              getClientCountOwnСlient(getClientsParticipationGroup(clients)) +
              ' / ' +
              getClientCountFromAdvertising(getClientsParticipationGroup(clients))
            : '-'}
        </div>
        <Link className={styles.interaction_link} to={`/${pathHome}/addParticipants/${group_id}`}>
          <svg
            className={styles.interaction_link_svg}
            width="35"
            height="36"
            viewBox="0 0 35 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect y="2.60376" width="34.7273" height="33.0189" rx="10" fill="#A22CA7" />
            <path
              d="M16.2182 26.4091V11.4091H18.7636V26.4091H16.2182ZM9.99089 20.1818V17.6364H24.9909V20.1818H9.99089Z"
              fill="white"
            />
          </svg>
        </Link>
      </div>
      {/* -------------- /Header ------------------------ */}
      <div className={styles.content_wrapper}>
        {clients.length && getClientsParticipationGroup(clients).length ? (
          <div className={styles.control_button_wrapper}>
            <button
              className={styles.control_btn + ' ' + styles.delete_allAccess}
              onClick={() => accessToMenu(getClientsParticipationGroup(clients), false)}>
              Заборонити всім
            </button>
            <button
              className={styles.control_btn + ' ' + styles.add_allAccess}
              onClick={() => accessToMenu(getClientsParticipationGroup(clients), true)}>
              Дозволити всім
            </button>
          </div>
        ) : (
          ''
        )}

        <div className={styles.clients_wrapper}>
          {clients.length && getClientsParticipationGroup(clients).length ? (
            renderClientsParticipationGroup(getClientsParticipationGroup(clients))
          ) : loaderPage ? (
            <div>Загрузка...</div>
          ) : (
            <div>Пусто:)</div>
          )}
        </div>
      </div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
